<mdb-card class="h-100" [class.border-active]="borderActive" [cascade]="cascade">
  <mdb-card-header class="p-0">
    <ng-content select="[header]"></ng-content>
  </mdb-card-header>
  <mdb-card-header
    *ngIf="titleKey || title"
    class="bg-main py-3 card-header font-weight-bold"
    [class.h5]="size === 'md'"
    [class.h6]="size === 'sm'"
    (click)="handleCollapse()"
    data-toggle="collapse"
    data-target="card-body"
    aria-expanded="false"
  >
    <div class="row align-items-center">
      <div class="col-auto">
        <ng-template [ngIf]="icon && icon.startsWith('baryicon')">
          <i [class]="' mr-1 icon ' + icon"></i>
        </ng-template>
        <ng-template [ngIf]="icon && !icon.startsWith('baryicon')">
          <jhi-bary-icon [icon]="icon" [faDirective]="FAS" class="mr-1"></jhi-bary-icon>
        </ng-template>
        <div *ngIf="withSwitch" class="switch primary-switch text-right d-inline">
          <label>
            <input type="checkbox" (change)="handleSwitchChange(!checked)" [checked]="checked" [disabled]="disabled" />
            <span class="lever"></span>
          </label>
        </div>
        <span [jhiTranslate]="titleKey" *ngIf="titleKey" [translateValues]="titleValue">{{ titleKey }}</span>
        <span *ngIf="title" class="align-middle">{{ title }}</span>
        <span class="font-italic font-weight-light" *ngIf="disabled && disabledMessage">{{ disabledMessage }}</span>
      </div>
      <div class="col" *ngIf="withCollapse">
        <jhi-bary-icon icon="angle-down" [faDirective]="FAS" class="float-right" [hidden]="_collapseState"></jhi-bary-icon>
        <jhi-bary-icon icon="angle-up" [faDirective]="FAS" class="float-right" [hidden]="!_collapseState"></jhi-bary-icon>
      </div>
      <div *ngIf="tooltip" class="flex-grow-1 text-right mr-3" [mdbTooltip]="tooltip">
        <i class="fa fa-exclamation-circle float-right text-primary"></i>
      </div>
    </div>
  </mdb-card-header>
  <mdb-card-body #cardBody [id]="'card-body-' + id" [class.collapse]="withCollapse && !_collapseState">
    <ng-content select="[body]"></ng-content>
  </mdb-card-body>
  <mdb-card-footer class="bg-white p-0">
    <ng-content select="[footer]"></ng-content>
  </mdb-card-footer>
</mdb-card>
